module.exports = __webpack_public_path__ + "img/new_top_bg.1212f976.png";